import * as Storage from "../lib/Storage.ts";

const ACTIVATION_STATE_KEY = "HOMEHUB_ACTIVATION_STATE";

// Only facts the client cannot re-derive are persisted. Authentication comes from
// the authorization token and Premium eligibility is re-read from the account
// credits, so neither is stored here.
type ActivationJourney = {
  offerCode: string;
};

function readJourney(): ActivationJourney | undefined {
  const storedJourney = Storage.sessionGet(ACTIVATION_STATE_KEY);
  if (!storedJourney) return undefined;
  try {
    const journey = JSON.parse(storedJourney) as ActivationJourney;
    return journey.offerCode ? journey : undefined;
  } catch {
    return undefined;
  }
}

function writeJourney(journey: ActivationJourney) {
  Storage.sessionSet(ACTIVATION_STATE_KEY, JSON.stringify(journey));
}

export function markOfferCodeValidated(offerCode: string) {
  writeJourney({ offerCode });
}

export function hasValidatedOfferCode(): boolean {
  return readJourney() !== undefined;
}

export function getOfferCode(): string | undefined {
  return readJourney()?.offerCode;
}

export function resetActivationJourney() {
  Storage.sessionRemove(ACTIVATION_STATE_KEY);
}
